import React from 'react';

const OrderInfo = ({ id, billingAddress = {} }) => {
    const { firstName = '', lastName = '' } = billingAddress;
    const userName = `${firstName} ${lastName}`;
    return (
        <h3 className="margin-b0" style={{ color: '#cc0000', fontFamily: 'Rajdhani-Medium' }}>
            <span className="inline-block padding-r10">Order #{id}</span>
            <span className="inline-block capitalize">Customer Name: {userName}</span>
        </h3>
    );
};

export default OrderInfo;
